export default "__VITE_PUBLIC_ASSET__6594d502__"